export const aboutData = {
  brandName: '91制片厂',
  brandSlogan: '用心创作，让每一帧都值得',
  foundedYear: '2018',
  teamSize: '500+',
  totalWorks: '2,000+',
  totalUsers: '5,000万+',
  introduction: `91制片厂成立于2018年，总部位于北京，是一家专注于优质影视内容创作与发行的综合性文化传媒平台。秉承"用心创作，让每一帧都值得"的理念，我们致力于打造国内一流的原创影视内容生态。`,
  story: [
    {
      year: '2018',
      title: '梦想启航',
      description: '三位怀揣电影梦想的年轻人在北京创立91制片厂，初期只有一个小型工作室和五人的团队，但拥有无限的创作热情。',
    },
    {
      year: '2019',
      title: '初露锋芒',
      description: '推出首部原创短片《城市之光》，获得多个独立电影节奖项，开始受到业内关注。同年完成首轮融资，团队扩展至30人。',
    },
    {
      year: '2020',
      title: '快速发展',
      description: '平台正式上线运营，月活跃用户突破100万。建立自有摄影棚和后期制作中心，实现从创意到成片的完整制作链。',
    },
    {
      year: '2021',
      title: '内容爆发',
      description: '年产出原创影视作品超过300部，涵盖电影、剧集、纪录片等多种类型。与国内外多家发行平台达成战略合作。',
    },
    {
      year: '2022',
      title: '品质升级',
      description: '启动"精品计划"，加大头部内容投入。引进好莱坞级制作设备和技术团队，全面升级制作水准。',
    },
    {
      year: '2023',
      title: '生态构建',
      description: '建立创作者扶持计划，为优秀独立制片人提供从资金到发行的全链路支持。平台注册用户突破3000万。',
    },
    {
      year: '2024',
      title: '走向世界',
      description: '多部原创作品入选国际电影节，开启海外发行。推出会员专属内容体系，打造完整的影视消费生态闭环。',
    },
  ],
  values: [
    {
      title: '品质至上',
      description: '每一部作品都经过严格的内容审核和品质把控，我们坚信好内容是最好的名片。',
      icon: 'ri-star-line',
    },
    {
      title: '创新驱动',
      description: '持续探索新的叙事方式和制作技术，用创新为观众带来前所未有的视听体验。',
      icon: 'ri-lightbulb-line',
    },
    {
      title: '创作者为本',
      description: '尊重每一位创作者的独特表达，为优秀人才提供最自由的创作空间。',
      icon: 'ri-user-heart-line',
    },
    {
      title: '用户至上',
      description: '以用户需求为导向，不断优化观影体验，打造最懂观众的影视平台。',
      icon: 'ri-customer-service-2-line',
    },
  ],
  testimonials: [
    {
      name: '张艺谋',
      title: '著名导演',
      content: '91制片厂为年轻电影人提供了一个非常宝贵的平台，他们的原创精神和对品质的执着让我印象深刻。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20middle-aged%20Chinese%20man%20in%20dark%20suit%2C%20studio%20portrait%20lighting%2C%20clean%20gray%20background%2C%20professional%20photography&width=120&height=120&seq=avatar-01&orientation=squarish',
    },
    {
      name: '宁浩',
      title: '导演、编剧',
      content: '与91制片厂的合作让我们看到了中国原创影视的无限可能，他们拥有非常专业的内容团队和敏锐的市场洞察力。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20man%20with%20glasses%20in%20casual%20blazer%2C%20studio%20portrait%2C%20clean%20background%2C%20warm%20lighting&width=120&height=120&seq=avatar-02&orientation=squarish',
    },
    {
      name: '贾樟柯',
      title: '导演、制片人',
      content: '91制片厂是一个真正懂得尊重创作者、理解观众需求的平台。在这里，好故事永远不会被埋没。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20man%20in%20dark%20shirt%2C%20studio%20portrait%20lighting%2C%20clean%20background%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-03&orientation=squarish',
    },
  ],
  contact: {
    address: '北京市朝阳区建国路88号SOHO现代城A座15层',
    phone: '400-xxx-xxxx',
    email: 'service@91pianzhi.com',
    wechat: '91制片厂官方',
    weibo: '@91制片厂',
    businessHours: '周一至周五 9:00 - 18:00',
  },
};